import type { AdminUser, LoginRequest, LoginResponse } from '@jiaofa/api-types'
import { request } from './request'

export const authApiReady = true as const

export interface ChangePasswordPayload {
  oldPassword: string
  newPassword: string
}

export const login = async (payload: LoginRequest): Promise<LoginResponse> =>
  request<LoginResponse, LoginRequest>({
    url: '/auth/login',
    method: 'POST',
    data: payload,
  })

export const logout = async (): Promise<void> =>
  request<void>({
    url: '/auth/logout',
    method: 'POST',
  })

export const fetchCurrentUser = async (): Promise<AdminUser> =>
  request<AdminUser>({
    url: '/auth/me',
    method: 'GET',
  })

export const changePassword = async (payload: ChangePasswordPayload): Promise<void> =>
  request<void, ChangePasswordPayload>({
    url: '/auth/change-password',
    method: 'POST',
    data: payload,
  })
